import { MessageProps } from "@/models/payload/messages";
import messageService from "@/services/messages";
import { useInfiniteQuery } from "@tanstack/react-query";

type Props = {
  params: MessageProps;
};

function useGetMessagesRequest({ params }: Props) {
  const {
    data,
    isLoading,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ["allMessageRequest", params?.ServiceType],
    queryFn: ({ pageParam = 0 }) =>
      messageService.getAllMessagesRequest({ ...params, Skip: pageParam }),
    getNextPageParam: (lastPage, allPages) => {
      const morePagesExist = lastPage?.result?.length === params.Count; // Assuming 10 items per page
      if (!morePagesExist) return undefined;
      return allPages.length * (params?.Count || 10); // Next page's skip value
    },
  });

  return {
    data,
    isLoading,
    refetch,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
  };
}

export default useGetMessagesRequest;
